<lib-portal-skeleton>
    <app-logo-supplier logoSupplier></app-logo-supplier>
    <app-favorite-selector favorite></app-favorite-selector>
    <app-sidebar-content sidebarContent></app-sidebar-content>
    <app-language-selector languageSelector></app-language-selector>
    <app-user-name class="d-flex align-items-center" userName></app-user-name>
</lib-portal-skeleton>
